import PropTypes from 'prop-types';

export const authorizationUrlsProps = PropTypes.shape({
  google: PropTypes.string.isRequired,
  facebook: PropTypes.string.isRequired
});

export default { authorizationUrlsProps };
